import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		plannedRegions: []
	},

	actions: {
		fetchAll({ commit }, { fromDate, toDate }) {
			return window.axios.get('/region-plans/planned-region', { params: { fromDate, toDate } }).then(({ data }) => {
				commit(types.STORE_PLANNED_REGIONS, data);
				return data;
			})
		},

		fetchById({ commit }, { id }) {
			return window.axios.get(`/region-plans/planned-region/${id}`).then(({ data }) => data);
		},

		create({ commit }, { regionPlanId, regionId, date, note }) {
			return window.axios.post('/region-plans/planned-region', { regionPlanId, regionId, date, note });
		},

		createBulk({ commit }, { regionPlanId, regionIds, date, note, employeeId }) {
			return window.axios.post('/region-plans/planned-region/bulk', { regionPlanId, regionIds, date, note, employeeId });
		},

		update({ commit }, { id, regionPlanId, regionId, date, note }) {
			return window.axios.put(`/region-plans/planned-region/${id}`, { regionPlanId, regionId, date, note });
		},

		delete({ commit }, { id }) {
			return window.axios.delete(`/region-plans/planned-region/${id}`);
		},

		clear({ commit }) {
			commit(types.CLEAR_PLANNED_REGIONS)
		},
	},

	mutations: {
		[types.STORE_PLANNED_REGIONS](state, plannedRegions) {
			state.plannedRegions = plannedRegions;
		},

		[types.CLEAR_PLANNED_REGIONS](state) {
			state.plannedRegions = [];
		},
	},

	getters: {
		getPlannedRegionById: state => id => state.plannedRegions.find(c => c.id === id)
	}
}
